import styled from 'styled-components';
import LogoDarkAdmin from './LogoDarkAdmin';

const LogoDarkAdminStyled = styled(LogoDarkAdmin)`
  display: flex;
  flex-flow: column;
`;

export default LogoDarkAdminStyled;
